import ApiOptions from '~/api/v4/api-options';
import Client from '~/types/api/api-module';

const WALLET_VJI_URL = `${process.env.API_PAYMENT_HOST}/v1/payment/wallet-vji`;
const PAYMENT_SCOPE = 'payment.*.*';

export default Client.wrap({
  generateWalletVjiB2b2cToken() {
    return this.post(`${WALLET_VJI_URL}/b2b2c-token`, PAYMENT_SCOPE, {
      enableAuthHeader: true,
      ...new ApiOptions({ requestPayload: {} }),
    });
  },
});
